import "bootstrap/dist/css/bootstrap.css";

import * as React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import WebFont from "webfontloader";

import { configureStore } from "./store";

import reportWebVitals from './reportWebVitals';
import { StaticDataContext } from "./contexts";
import { InitialState } from "./types";
import ReactGA from 'react-ga4';

import App from "./App";

WebFont.load({
    google: {
      families: ['Titillium Web:300,400,500,700', 'sans-serif']
    }
 });

 ReactGA.initialize([
    {
      trackingId: "G-XPXCCDP0XY"
    }
]);

 declare global {
    var SERVER_DATA: Readonly<InitialState> | undefined;
}

let promise: Promise<Readonly<InitialState>>;

if (process.env.NODE_ENV === "production") {
    const serverData = window.SERVER_DATA;
    delete window.SERVER_DATA;
    promise = Promise.resolve(serverData!);
} else {
    const { pathname } = window.location;

    if (pathname === "/") {
        promise = import("./data.json").then<InitialState>();
    } else {
        window.location.assign("/");
        promise = Promise.reject();
    }
}

promise.then(({ configuration, staticData }) => {
    console.debug("Configuration from server", configuration);

    // Get the application-wide store instance, prepopulating with state from the server where available.
    const store = configureStore(configuration);

    const root = createRoot(document.getElementById("root")!);
    
    root.render(<React.StrictMode>
        <StaticDataContext.Provider value={staticData}>
            <Provider store={store}>
                <App />
            </Provider>
        </StaticDataContext.Provider>
    </React.StrictMode>)
});

window.addEventListener("popstate", function () {
    // Reload on popstate to reload state
    window.location.reload();
});

reportWebVitals(console.debug);
